<app-roster-roster-link [termCode]="termCode" [crn]="crn"></app-roster-roster-link>
